import type { PortableTextBlock } from "@portabletext/types";

/**
 * Renumbers list item levels by their nesting depth among the preceding list
 * items, removing gaps between authored levels.
 *
 * Portable Text nests lists strictly by `level` and fills skipped levels with
 * empty list items, which render as blank bullets or consume ordered-list
 * numbers. Each item's depth is the count of open ancestors with a lower
 * authored level, so items at the same authored level stay siblings and
 * relative indentation order is preserved.
 */
function clampListItemLevels(blocks: PortableTextBlock[]): PortableTextBlock[] {
  const ancestorLevels: number[] = [];

  return blocks.map((block) => {
    if (block._type !== "block" || !block.listItem) {
      ancestorLevels.length = 0;
      return block;
    }

    const authoredLevel = block.level ?? 1;

    while (
      ancestorLevels.length > 0 &&
      (ancestorLevels[ancestorLevels.length - 1] ?? 0) >= authoredLevel
    ) {
      ancestorLevels.pop();
    }

    ancestorLevels.push(authoredLevel);
    const level = ancestorLevels.length;

    return level === authoredLevel ? block : { ...block, level };
  });
}

export { clampListItemLevels };
